module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><polygon points=\"8 12 14 17 14 7 8 12\"></polygon></svg>"